import ClientInstallationDetails from 'modules/client-installation/components/ClientInstallationDetails/ClientInstallationDetails';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const ClientInstallationDetailPage = () => {
    return (
        <PageTemplate>
            <PageHeading>Client Installation Details</PageHeading>
            <ClientInstallationDetails />
        </PageTemplate>
    );
};

export default ClientInstallationDetailPage;
